/** ISO 3166-1 alpha-2 codes used for catalog and organization-unit country scoping. */
export const ISO_COUNTRY_CODES = ['AT', 'CH', 'DE', 'IT', 'NL'] as const;

export type IsoCountryCode = (typeof ISO_COUNTRY_CODES)[number];

export const ISO_COUNTRY_LABELS: Record<IsoCountryCode, string> = {
  AT: 'Austria',
  CH: 'Switzerland',
  DE: 'Germany',
  IT: 'Italy',
  NL: 'Netherlands',
};
